function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_693",
  "data-name": "Group 693"
}, React.createElement("g", {
  id: "Group_689",
  "data-name": "Group 689"
}, React.createElement("path", {
  id: "Path_419",
  "data-name": "Path 419",
  d: "M20.45,40.9A20.45,20.45,0,1,1,40.9,20.45,20.472,20.472,0,0,1,20.45,40.9Zm0-35.725A15.275,15.275,0,1,0,35.725,20.45,15.293,15.293,0,0,0,20.45,5.175Z",
  fill: "gray"
})), React.createElement("g", {
  id: "Group_692",
  "data-name": "Group 692",
  transform: "translate(17.185 11.093)"
}, React.createElement("g", {
  id: "Group_690",
  "data-name": "Group 690",
  transform: "translate(0.594)"
}, React.createElement("circle", {
  id: "Ellipse_50",
  "data-name": "Ellipse 50",
  cx: 2.37,
  cy: 2.37,
  r: 2.37,
  fill: "gray"
})), React.createElement("g", {
  id: "Group_691",
  "data-name": "Group 691",
  transform: "translate(0 6.987)"
}, React.createElement("path", {
  id: "Path_420",
  "data-name": "Path 420",
  d: "M211.431,227.626H204.9v-3.168h1.2v-5.391h-1.181V215.9h5.318v8.559h1.2Z",
  transform: "translate(-204.9 -215.9)",
  fill: "gray"
}))));

const SvgInfo = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "info",
    width: 40.9,
    height: 40.9,
    viewBox: "0 0 40.9 40.9",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Info.ee0021ea.svg";
export { ForwardRef as ReactComponent };